import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import News from "../components/News/News";
import Searchbar from "../components/Searchbar/Searchbar";
import { fetchStaticData } from "../services/tweetService";
import { BASE_WEB_URL } from "../CONSTANTS";

export default function About() {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [about, setAbout] = useState("");
  useEffect(() => {
    fetchStaticData('about').then(data => setAbout(data));
  }, [dispatch]);

  return (
    <>
      <div className="notificationspage two-flex-col-container">
        <div className="col1 npc-1">
          {about && <><div className="notificationspage-header">
            <span className="notifications-text">{about.title}</span>
          </div>
            <p style={{margin: '1rem'}}>{about.content}</p>
          <div className="constitution-div">
          {about != '' &&  <embed src={ BASE_WEB_URL + about.asset_file}/>}
          </div></>}
        </div>
        <div className="col2 follow-sugg-news-container">
          <div className="follow-sugg-news-wrap">
            <Searchbar input={searchQuery}
              setInput={(value) => setSearchQuery(value)}/>
            <News />
            {/* <WhoToFollow /> */}
          </div>
        </div>
      </div>
    </>
  );
}
